import axios from 'axios';

import { doctorApiV2BaseUrl } from './api';
import { refreshTokenStorage, tokenStorage } from './storage';

// Local replacement for @medicusunion/front-utils Jwt: the /api/v2 doctor BE
// returns BARE {accessToken, refreshToken} (no {data} envelope) and takes no
// `credential` header. front-utils Jwt expects the legacy envelope and is
// shared with the patient/admin fronts, so it cannot change.
// Plain axios (not `instance`) — the instance 401 interceptor calls this,
// and going through it again would recurse.
export const jwt = {
  async refreshToken(): Promise<string | null> {
    try {
      const res = await axios.post(
        'auth/refresh-token',
        { refreshToken: refreshTokenStorage.get() },
        { baseURL: doctorApiV2BaseUrl }
      );

      const { accessToken, refreshToken } = res.data;

      tokenStorage.set(accessToken);
      refreshTokenStorage.set(refreshToken);

      return accessToken;
    } catch {
      tokenStorage.remove();
      refreshTokenStorage.remove();

      return null;
    }
  }
};
